import React from "react";
import Shimmer from "../Shimmer";

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTabIds: string[];
  onTabClick: (id: string) => void;
  removable?: boolean; // optional, show/remove close icon
  isLoading?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTabIds,
  onTabClick,
  removable = true,
  isLoading = false,
}) => {
  return (
    <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide">
      {isLoading ? (
        <div className="flex items-center gap-4 overflow-x-auto">
          {Array.from({ length: 4 }).map((_, index) => (
            <Shimmer
              key={index}
              width="100px"
              height="32px"
              rounded="rounded-full"
            />
          ))}
        </div>
      ) : (
        tabs
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((tab) => (
            <div
              key={tab.id}
              className={`flex items-center text-sm px-3 py-1 rounded-full flex-shrink-0 border cursor-pointer ${
                activeTabIds.includes(tab.id)
                  ? "bg-[var(--app-primary)]/10 border-[var(--app-primary)] text-[var(--app-primary)] bg-[var(--icon-bg-primary)]"
                  : "bg-gray-200 border-gray-300 text-gray-500"
              }`}
              onClick={() => onTabClick(tab.id)}
            >
              <span>{tab.label}</span>
              {removable && activeTabIds.includes(tab.id) && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3 ml-2 hover:text-red-500 flex-shrink-0"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  onClick={(e) => {
                    e.stopPropagation();
                    onTabClick(tab.id); // toggle/deselect
                  }}
                >
                  <path
                    fillRule="evenodd"
                    d="M10 8.586L4.707 3.293A1 1 0 103.293 4.707L8.586 10l-5.293 5.293a1 1 0 101.414 1.414L10 11.414l5.293 5.293a1 1 0 001.414-1.414L11.414 10l5.293-5.293a1 1 0 00-1.414-1.414L10 8.586z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </div>
          ))
      )}
    </div>
  );
};

export default Tabs;
